import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import App from "../App";
import LobConstants from "../constants/LobConstants";

//Routes
export default (
  <Router>
    <Switch>
      <Route path={`/${LobConstants.LOB}`} component={App} />
    </Switch>
  </Router>
);